export default "__VITE_ASSET__Bvoo0J5Y__"